<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="23" height="23" rx="5.5" fill="#9600F1" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.8334 8.29407C17.0392 8.4782 17.0568 8.7943 16.8726 9.00009L11.206 15.3334C11.1082 15.4426 10.9675 15.5035 10.821 15.4999C10.6745 15.4963 10.5369 15.4285 10.4447 15.3146L7.61139 11.8146C7.43765 11.6 7.47079 11.2852 7.68542 11.1114C7.90005 10.9377 8.21489 10.9708 8.38864 11.1854L10.8524 14.2289L16.1274 8.33329C16.3115 8.1275 16.6276 8.10994 16.8334 8.29407Z"
      fill="white"
    />
    <rect x="0.5" y="0.5" width="23" height="23" rx="5.5" stroke="#9600F1" />
  </svg>
</template>

<script>
export default {
  name: 'TamaraCheckoutOnLavender',
}
</script>
